function valuesMatch(item,lookFor){
    return Object.keys(lookFor).findIndex(key => lookFor[key] !== item[key]) === -1;
}

export function firstMatch(arr,lookFor) {
    return arr.findIndex(item => valuesMatch(item,lookFor));
}

export function filterMatches(arr,lookFor) {
    return arr.filter(item => !valuesMatch(item,lookFor));
}

export function filterUnMatches(arr,lookFor) {
    return arr.filter(item => !valuesMatch(item,lookFor));
}

export function inclusiveRange(start, end, step) {
    return Array.from(Array.from(Array(Math.ceil((end-start+1)/step)).keys()), x => start+ x*step);
}